<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_v">CONTENTS</a></h2><a id="page_v">
<p class="txba"><img alt="image" src="images/common.jpg"/></p>
</a><p class="toc-ct"><a id="page_v"></a><a class="nounder" href="#/xhtml/Intro">INTRODUCTION</a></p>
<p class="toc-sub"><em>Our Angry World</em></p>
<p class="toc-ct"><a class="nounder" href="#/xhtml/ch01">Chapter 1: DEFINITIONS</a></p>
<p class="toc-sub"><em>Anger: The Good, the Bad, and the Destructive</em></p>
<p class="toc-ct"><span class="nounder" href="#/xhtml/ch02" title="Link target outside of Sample">Chapter 2: EXPRESSIONS</span></p>
<p class="toc-sub"><em>The Three Ways Anger Is Manifested</em></p>
<p class="toc-ct"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample">Chapter 3: CONSEQUENCES</span></p>
<p class="toc-sub"><em>Anger’s Impact on Us, Others, and God</em></p>
<p class="toc-ct"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample">Chapter 4: ROOTS</span></p>
<p class="toc-sub"><em>Exploring the Causes of Anger</em></p>
<p class="toc-ct"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample">Chapter 5: RELEASE</span></p>
<p class="toc-sub"><em>Letting Go of Anger</em></p>
<p class="toc-ct"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample">Chapter 6: CURE</span></p>
<p class="toc-sub"><em>The Balm for Anger: Forgiveness</em></p>
<p class="toc-ct"><span class="nounder" href="#/xhtml/ch07" title="Link target outside of Sample">Chapter 7: REBELLION</span></p>
<p class="toc-sub"><em>Anger Aimed at God</em></p>
<p class="toc-ct"><span class="nounder" href="#/xhtml/ch08" title="Link target outside of Sample">Chapter 8: PEACE</span></p>
<p class="toc-sub"><em>Establishing Personal Peace in an Angry World</em></p>
<p class="toc-ct"><span class="nounder" href="#/xhtml/ch09" title="Link target outside of Sample">Chapter 9: RELATIONSHIPS</span></p>
<p class="toc-sub"><em>Living with Angry People—or Not</em></p>
<p class="toc-ct"><a id="page_vi"></a><span class="nounder" href="#/xhtml/ch10" title="Link target outside of Sample">Chapter 10: CHARACTER</span></p>
<p class="toc-sub"><em>Establishing Peace in Yourself and<br/>Training Your Children in Love</em></p>
<p class="toc-ct"><span class="nounder" href="#/xhtml/ch11" title="Link target outside of Sample">Chapter 11: CONFLICT</span></p>
<p class="toc-sub"><em>Confronting Conflict in a Godly Manner</em></p>
<p class="toc-ct"><span class="nounder" href="#/xhtml/ch12" title="Link target outside of Sample">Chapter 12: PURPOSE</span></p>
<p class="toc-sub"><em>A Case Study of God-Engineered Conflict</em></p>
<p class="toc-ct"><span class="nounder" href="#/xhtml/ch13" title="Link target outside of Sample">Chapter 13: OPPORTUNITY</span></p>
<p class="toc-sub"><em>The Potential for Personal Growth</em></p>
<p class="toc-ct"><span class="nounder" href="#/xhtml/ch14" title="Link target outside of Sample">CONCLUSION</span></p>
<p class="toc-sub"><em>If You Are Not a Christian …</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?5d3bfddc